import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { AdsComponent } from '../../components/ads/ads.component';
import { CommonNewsComponent } from '../../components/common-news/common-news.component';
import { DiscoverEventsComponent } from '../../components/discover-events/discover-events.component';
import { FeaturedFeedComponent } from '../../components/featured-feed/featured-feed.component';
import { HomeBannerComponent } from '../../components/home-banner/home-banner.component';
import { MultiElementIdentityComponent } from '../../components/multi-element-identity/multi-element-identity.component';
import { ShopGearComponent } from '../../components/shop-gear/shop-gear.component';
import { SportsExplorerComponent } from '../../components/sports-explorer/sports-explorer.component';
import { SportsMarqueeComponent } from '../../components/sports-marquee/sports-marquee.component';
import { SupportJourneyComponent } from '../../components/support-journey/support-journey.component';
import { TabToTopComponent } from '../../components/tab-to-top/tab-to-top.component';
import { TheSystemComponent } from '../../components/the-system/the-system.component';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { LIMIT, MAX_SIZE } from '../../utils/constants';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    HomeBannerComponent,
    MultiElementIdentityComponent,
    SportsMarqueeComponent,
    SportsExplorerComponent,
    SupportJourneyComponent,
    TheSystemComponent,
    ShopGearComponent,
    DiscoverEventsComponent,
    FeaturedFeedComponent,
    // AdsComponent,
    CommonNewsComponent,
    RouterLink,
    TabToTopComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('childContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('homeVideo') homeVideo!: ElementRef<HTMLVideoElement>;
  userDetail: any;
  public userLoggedIn = false;
  public expertUser = false;
  public isVideoMuted = true;
  sportList = [];
  feedList = 0;
  featuredFeedList = 0;
  eventList = 0;
  xdgeStoreList: any = [];
  xdgeNewsList: any = 0;
  bannerList: any = [];
  topSportSequence: any = [];
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };

  fileDirectoriesPath: any = fileDirectories.profile;
  constructor(
    private _apiService: ApiCallsService,
    private changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _storageService: BrowserStorageService,
    private _userService: UserService,
    private _ngbModal: NgbModal,
    private viewportScroller: ViewportScroller,
    private route: ActivatedRoute,
  ) {
    if (this._storageService.getBrowser()) {
      this._router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.viewportScroller.scrollToPosition([0, 0]);
          this.applyVideoMute(true);
        }
      });
      if (this._storageService.getBrowser()) {
        // Inject Banner Data only on Client Side
        this.bannerList = this.route.snapshot.data['data']['bannerData'];
      }
    }
  }

  ngOnInit(): void {
    if (this._storageService.getBrowser()) {
      this._userService.user.subscribe((user) => {
        if (user) {
          this.userDetail = user;
          this._getUserData(this.userDetail);
          this.changeDetectorRef.detectChanges();
        }
        this.getTopSport();
      });
    }
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (!this.userDetail) {
      this.loadChild();
    }
    this.applyVideoMute(true);
  }

  async loadChild() {
    this.container.clear();
    const { EvaluateSkillsComponent } = await import('../../components/evaluate-skills/evaluate-skills.component');
    this.container.createComponent(EvaluateSkillsComponent);
  }

  private _getUserData(userDetail: any): void {
    let webDetails = userDetail;
    if (webDetails) {
      this.userLoggedIn = true;
    } else {
      this.userLoggedIn = false;
    }
    if (webDetails?.registrationReason == 1 || webDetails?.isExpert) {
      this.expertUser = true;
    } else {
      this.expertUser = false;
    }
  }
  viewAll(path: any, entity: any) {
    // Allow non-logged-in users to view store
    if (path === '/store') {
      this._router.navigate([path]);
      return;
    }

    this.userDetail = this._storageService.getItem('userDetail');
    if (this.userDetail) {
      this._router.navigate([path]);
    } else {
      let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
      if (entity) {
        modalRef.componentInstance.entity = entity;
      }
    }
  }

  onExploreClick() {
    let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'filterPopup',
      centered: true,
    });
  }
  getTopSport() {
    this._apiService.post(api._sportListing, { topSportSequence: true, limit: 5 }).subscribe({
      next: (res: any) => {
        this.topSportSequence = res.data.rows;
      },
      error: (error: any) => console.log(error),
    });
  }

  scrollToEvaluateSkills() {
    this.viewportScroller.scrollToAnchor('evaluateSkillsSection');
  }

  applyVideoMute(shouldMute: boolean) {
    this.isVideoMuted = shouldMute;
    if (this.homeVideo?.nativeElement) {
      this.homeVideo.nativeElement.muted = shouldMute;
    }
  }

  toggleVideoSound() {
    this.applyVideoMute(!this.isVideoMuted);
  }
}
